// Orders Page

// Approval Requests Page
export const APPROVALS_NONSTOCKED_SSD_TAB = 'approvalsNonStockedSSD'
export const APPROVALS_EXCEPTION_TESTING_TAB = 'approvalsExceptionTesting'
export const APPROVALS_RESHIPMENTS_TAB = 'approvalsReshipments'
export const APPROVALS_ANCILLARY_MATERIALS_TAB = 'approvalsAncillaryMaterials'
export const APPROVALS_ORDERS_AFTER_DEADLINE_TAB = 'approvalsOrdersAfterDeadline'
export const APPROVALS_OFFCYCLE_TESTING_TAB = 'approvalsOffCycleTesting'

// Approvals Tab sub-tab count request
export const FETCH_APPROVALS_TAB_COUNTS_PENDING = 'FETCH_APPROVALS_TAB_COUNTS_PENDING'
export const FETCH_APPROVALS_TAB_COUNTS_FULFILLED = 'FETCH_APPROVALS_TAB_COUNTS_FULFILLED'
export const FETCH_APPROVALS_TAB_COUNTS_REJECTED = 'FETCH_APPROVALS_TAB_COUNTS_REJECTED'
export const UPDATE_APPROVALS_TAB_COUNTS_PENDING = 'UPDATE_APPROVALS_TAB_COUNTS_PENDING'
export const UPDATE_APPROVALS_TAB_COUNTS_FULFILLED = 'UPDATE_APPROVALS_TAB_COUNTS_FULFILLED'

// Settings Page
